import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from '@stateManagement/TranslationContext';
import { getTranslation } from '@helpers/languageTranslations';
import { breakpoints, colors, getRgbaColor, Heading, Text, typographyStyles } from '@web-for-marketing/react-ui';

const classes = {
    container: {
        padding: '3.2rem 0',
    },
    divider: {
        ...typographyStyles.body2,
        [`@media (max-width: ${breakpoints.sm})`]: {
            display: 'none',
        },
    },
    userContact: {
        display: 'flex',
        flexDirection: 'row',
        gap: '0.8rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            flexDirection: 'column',
            gap: 0,
        },
    } as const,
    content: {
        '& > a': {
            color: colors.text.secondary,
            padding: '0.5rem 0.2rem',
            transition: '200ms background-color ease',
            '&:hover': {
                backgroundColor: `${getRgbaColor(colors.core.deepSpace, 0.03)} !important`,
            },
            '&:focus': {
                outlineColor: colors.text.secondary,
                backgroundColor: `${getRgbaColor(colors.core.deepSpace, 0.06)} !important`,
            },
            '&:active': {
                outline: 'none',
                backgroundColor: `${getRgbaColor(colors.core.deepSpace, 0.05)} !important`,
            },
        },
    },
};

export function MediaContact(): React.ReactElement {
    const { selectedLanguageTranslation } = useTranslation();

    const mediaContactTranslation = getTranslation(selectedLanguageTranslation, 'pressRelease', 'mediaContact');

    const aboutGeotabTranslation = getTranslation(selectedLanguageTranslation, 'aboutGeotab');

    return (
        <Stack direction='column' gap={3} css={classes.container}>
            <Stack direction='column' gap={1}>
                <Heading variant='h4' component='p' color='activePrimary'>
                    {mediaContactTranslation.title}
                </Heading>
                <div css={classes.userContact}>
                    {mediaContactTranslation.name ? (
                        <Text variant='body2' color='secondary'>
                            {mediaContactTranslation.name}
                        </Text>
                    ) : null}
                    {mediaContactTranslation.role ? (
                        <>
                            <div aria-hidden css={classes.divider}>
                                &#124;
                            </div>
                            <Text variant='body2' color='secondary'>
                                {mediaContactTranslation.role}
                            </Text>
                        </>
                    ) : null}
                    {mediaContactTranslation.email ? (
                        <>
                            <div aria-hidden css={classes.divider}>
                                &#124;
                            </div>
                            <Text variant='body2' color='secondary'>
                                {mediaContactTranslation.email}
                            </Text>
                        </>
                    ) : null}
                </div>
            </Stack>
            <Stack direction='column' gap={1}>
                <Heading variant='h4' component='h2' color='activePrimary'>
                    {aboutGeotabTranslation.main}
                </Heading>
                <Text
                    color='secondary'
                    variant='body2'
                    css={classes.content}
                    dangerouslySetInnerHTML={{ __html: aboutGeotabTranslation.content }}
                />
            </Stack>
        </Stack>
    );
}
